export default __webpack_public_path__ + "static/media/logoTablet.c169a7af.svg";